import React from 'react';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { SUMMARY_LABEL_SX, SummaryField } from './SummaryPaneComponents';
import { MultiselectSummary } from './SummaryPaneComponents';
import { useDailyRestrictionSelectors } from '../hooks';
import CurrentCapAmountByDomains from '../../../views/Offers/OfferActions/CurrentCapAmountByDomains';

const DailyRestrictionSummary = ({ criteriaType }) => {
  const dailyRestrictionSelectors = useDailyRestrictionSelectors();
  const showCapAmount = criteriaType === 'Offer Action Criteria';

  return (
    <>
      {dailyRestrictionSelectors.isAnySelectorNotNullOrEmpty && (
        <>
          <Typography variant='h4'>Daily Restriction Summary</Typography>
          <Grid container spacing={2} sx={{ alignItems: 'start' }}>
            {dailyRestrictionSelectors.criteriaDailyLimit && (
              <Grid size={{ xs: 12, lg: 6 }}>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Daily Limit</FormLabel>
                <SummaryField value={dailyRestrictionSelectors.criteriaDailyLimit} />
              </Grid>
            )}
            {dailyRestrictionSelectors.criteriaDailyLimitAnswers && (
              <Grid size={{ xs: 12, lg: 6 }}>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Answers</FormLabel>
                <MultiselectSummary value={dailyRestrictionSelectors.criteriaDailyLimitAnswers} />
              </Grid>
            )}
          </Grid>
          <Grid container spacing={2} sx={{ alignItems: 'start' }}>
            {dailyRestrictionSelectors.capInterval ? (
              <Grid size='grow'>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Cap Interval</FormLabel>
                <SummaryField value={dailyRestrictionSelectors.capInterval} />
              </Grid>
            ) : null}
            {dailyRestrictionSelectors.capAmount ? (
              <Grid size='grow'>
                <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Cap Amount</FormLabel>
                <SummaryField value={dailyRestrictionSelectors.capAmount} />
              </Grid>
            ) : null}
          </Grid>
          {dailyRestrictionSelectors.capSegmentConfiguration && (
            <>
              <Grid container spacing={2} sx={{ mt: 1, alignItems: 'start' }}>
                <Grid size='grow'>
                  <Typography variant='h5'>Cap Segment</Typography>
                </Grid>
              </Grid>
              {dailyRestrictionSelectors.capSegmentConfiguration.capSegments?.map((segment, index) => (
                <Grid container spacing={2} sx={{ mt: 1, alignItems: 'start' }} key={index}>
                  <Grid size='grow'>
                    <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Domains</FormLabel>
                    <MultiselectSummary value={segment.domains} />
                  </Grid>
                  <Grid size='grow'>
                    <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Segment Amount</FormLabel>
                    <SummaryField value={segment?.segmentAmount} />
                  </Grid>
                  <Grid size='grow'>
                    <CurrentCapAmountByDomains
                      id={dailyRestrictionSelectors.offerCriteriaId}
                      domains={segment.domains}
                    />
                  </Grid>
                </Grid>
              ))}
            </>
          )}
          {dailyRestrictionSelectors.criteriaDayHourRestrictions && (
            <>
              <Grid container spacing={2} sx={{ mt: 1, alignItems: 'start' }}>
                <Grid size='grow'>
                  <Typography variant='h5'>Day Partings{showCapAmount ? ' & Caps' : ''}</Typography>
                </Grid>
              </Grid>
              {dailyRestrictionSelectors.criteriaDayHourRestrictions?.map((restriction, index) => (
                <Grid container spacing={2} sx={{ mt: 1, alignItems: 'end' }} key={index}>
                  <Grid size={showCapAmount ? 2 : 3}>
                    <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Day</FormLabel>
                    <SummaryField value={restriction?.restrictionDay} />
                  </Grid>
                  <Grid size={showCapAmount ? 2 : 3}>
                    <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Restriction</FormLabel>
                    <SummaryField value={restriction?.restriction} />
                  </Grid>
                  {restriction?.restriction === 'Partially Restricted' && (
                    <>
                      <Grid size={2}>
                        <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Available Start</FormLabel>
                        <SummaryField value={restriction?.restrictionStart} />
                      </Grid>
                      <Grid size={2}>
                        <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Available End</FormLabel>
                        <SummaryField value={restriction?.restrictionEnd} />
                      </Grid>
                    </>
                  )}
                  {showCapAmount && restriction?.restriction !== 'Unavailable' && (
                    <Grid size={2}>
                      <FormLabel component='p' sx={SUMMARY_LABEL_SX}>Cap Amount</FormLabel>
                      <SummaryField value={restriction?.capAmount ?? ''} placeholder='No cap' />
                    </Grid>
                  )}
                </Grid>
              ))}
            </>
          )}
        </>
      )}
    </>
  );
};
export default DailyRestrictionSummary;
